module.exports = __webpack_public_path__ + "static/media/designerCut-02.0236e79c.png";